module.exports = __webpack_public_path__ + "img/欢欢.cbe4b413.jpg";